import React, {useCallback, useEffect, useState} from 'react';
import {TestScopeTabId, TestTypeTabId} from '../components/tabs/types';
import {OverlayScrollbarsComponentRef} from 'overlayscrollbars-react/types/OverlayScrollbarsComponent';
import {scrollContent} from '../utils';
import {DataService} from '../service/service';

type Props = {
	osRef: React.MutableRefObject<OverlayScrollbarsComponentRef<'div'>>,
	service: DataService,
	selfAssess?: boolean,
}

export function useDrawerState({osRef, service, selfAssess}: Props) {
	const [onlySelfAssess, setOnlySelfAssess] = useState(selfAssess);
	const [keyword, setKeyword] = useState('');
	const [testType, setTestType] = useState(selfAssess ? TestTypeTabId.YN : TestTypeTabId.All);
	const [scope, setScope] = useState(TestScopeTabId.All);
	const [contentAreaID, setContentAreaID] = useState('0');

	const toggleSelfAssessChecked = useCallback(() => setOnlySelfAssess((prev) => !prev), []);

	const onTestTypeChange = useCallback((type: TestTypeTabId) => {
		if (!service.loaded$) {
			return;
		}

		if (type) {
			setTestType(type);
		} else {
			setTestType(TestTypeTabId.All);
		}
	}, [service.loaded$]);

	const onScopeChange = useCallback((scope: TestScopeTabId) => {
		if (!service.loaded$) {
			return;
		}

		if (scope) {
			setScope(scope);
		} else {
			setScope(TestScopeTabId.All);
		}
	}, [service.loaded$]);

	useEffect(() => {
		service.tests$.next([]);
		scrollContent(osRef);
	}, [scope, testType, onlySelfAssess, keyword, contentAreaID, osRef, service.tests$]);

	return {
		contentAreaID,
		setContentAreaID,
		testType,
		onTestTypeChange,
		scope,
		onScopeChange,
		onlySelfAssess,
		toggleSelfAssessChecked,
		keyword,
		setKeyword,
	};
}
